<div class="flex items-center">

  <!-- Idle: open dialog -->
  @if (isIdle()) {
    <button
      (click)="openDialog()"
      class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors cursor-pointer">
      <elcia-icon [iconSize]="'md'" [iconType]="'clock'"/>
      <span class="font-mono text-lg">00:00:00</span>
    </button>
  }

  <!-- Running: stop + pulsing dot + elapsed time -->
  @if (isRunning()) {
    <div class="flex items-center gap-1">
      <button
        (click)="stopTimer()"
        class="flex items-center justify-center w-7 h-7 rounded-lg text-gray-500 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
        <span class="w-3 h-3 bg-current rounded-sm"></span>
      </button>
      <button
        (click)="openDialog()"
        class="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
        <span class="relative flex h-2.5 w-2.5">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
        </span>
        <span class="font-mono text-lg font-medium text-gray-700">{{ formattedTime() }}</span>
      </button>
    </div>
  }

  <!-- Stopped: resume + frozen time + edit -->
  @if (isStopped()) {
    <div class="flex items-center gap-1">
      <button
        (click)="resumeTimer()"
        class="flex items-center justify-center w-7 h-7 rounded-lg text-gray-500 hover:bg-green-50 hover:text-green-600 transition-colors cursor-pointer">
        <elcia-icon [iconSize]="'sm'" [iconType]="'play'"/>
      </button>
      <button
        (click)="openDialog()"
        class="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
        <span class="font-mono text-lg font-medium text-gray-400">{{ formattedTime() }}</span>
      </button>
      <button
        (click)="openDialog()"
        class="flex items-center justify-center w-7 h-7 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors cursor-pointer">
        <elcia-icon [iconSize]="'sm'" [iconType]="'edit'"/>
      </button>
    </div>
  }

</div>

@if (isDialogDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogAction()"
    (onClose)="closeDialog()"
    [actionIcon]="dialogActionIcon()"
    [actionLabel]="dialogActionLabel() | translate"
    [isActionLoading]="isSaving()"
    [size]="'x-small'">

    <ng-template #dialogHeader>
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center gap-2">
          <span class="text-xl font-bold text-gray-700">{{ 'entity.timesheet' | translate }}</span>
        </div>
        <div class="flex items-center gap-2">
          @if (isRunning()) {
            <button
              (click)="stopTimer()"
              class="flex items-center justify-center w-7 h-7 rounded-lg text-gray-500 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer">
              <span class="w-3 h-3 bg-current rounded-sm"></span>
            </button>
            <span class="relative flex h-2.5 w-2.5">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
            </span>
          }
          @if (isStopped()) {
            <button
              (click)="resumeTimer()"
              class="flex items-center justify-center w-7 h-7 rounded-lg text-gray-500 hover:bg-green-50 hover:text-green-600 transition-colors cursor-pointer">
              <elcia-icon [iconSize]="'sm'" [iconType]="'play'"/>
            </button>
          }
          <span
            [class.text-gray-400]="isStopped()"
            [class.text-gray-500]="isIdle()"
            [class.text-gray-700]="isRunning()"
            class="font-mono text-lg font-medium mr-4">{{ formattedTime() }}</span>
        </div>
      </div>
    </ng-template>

    <div class="flex flex-col gap-4 pt-2">

      <elcia-text-input
        [control]="form.controls.subject"
        [label]="'timesheet.subject' | translate"/>

      <elcia-timesheet-type-dropdown [control]="form.controls.timesheetTypeId" [isMulti]="false"/>

      <elcia-party-dropdown
        [control]="form.controls.concernedPartyId"
        [partyTypes]="partyTypes()"/>

      <div class="flex items-center gap-4">
        <elcia-toggle-switch [control]="form.controls.isBillable"
                             [label]="'timesheet.billable' | translate"/>
        @if (form.controls.isBillable.value) {
          <div class="flex-1">
            <elcia-numeric-input [control]="form.controls.billableDurationInMinutes"
                                 [label]="('timesheet.billable-duration' | translate) + ' '  + ('app.minutes' | translate)"
                                 [suffix]="'min'"/>
          </div>
        }
      </div>

      <elcia-text-area
        [control]="form.controls.description"
        [label]="'timesheet.description' | translate"/>

    </div>

  </elcia-dialog>
}
